"use strict";
/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * ČVS - API
 * OpenAPI spec version: 1.1.529
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleResponseModule = void 0;
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.ModuleResponseModule = {
    ADMIN: 'ADMIN',
    ADMIN2: 'ADMIN2',
    ADMIN3: 'ADMIN3',
    ADMINOLD2: 'ADMINOLD2',
    DIRECTORY: 'DIRECTORY',
    DIRECTORY2: 'DIRECTORY2',
    SURVEY: 'SURVEY',
    SURVEY2: 'SURVEY2',
    API: 'API',
    API_MAIN: 'API_MAIN',
    BANK: 'BANK',
    BANNER: 'BANNER',
    BANNER2: 'BANNER2',
    BEACH: 'BEACH',
    BEACH_DELEGATION: 'BEACH_DELEGATION',
    BEACH_REFEREE: 'BEACH_REFEREE',
    BEACH_FOLDERS: 'BEACH_FOLDERS',
    BEACH_STATISTIC: 'BEACH_STATISTIC',
    COMM: 'COMM',
    DELEGATES: 'DELEGATES',
    DM: 'DM',
    DM2: 'DM2',
    DOCUMENT: 'DOCUMENT',
    ESCORE: 'ESCORE',
    VOTING: 'VOTING',
    PLAYER: 'PLAYER',
    IMPORT: 'IMPORT',
    CALENDER: 'CALENDER',
    CALENDER2: 'CALENDER2',
    QUALIFICATION: 'QUALIFICATION',
    LICENSE: 'LICENSE',
    CHARTER: 'CHARTER',
    MEGAMENU: 'MEGAMENU',
    MEGAMENU2: 'MEGAMENU2',
    MM: 'MM',
    MM2: 'MM2',
    MSMT: 'MSMT',
    NSA: 'NSA',
    CLUB: 'CLUB',
    FAMOUS_PERSON: 'FAMOUS_PERSON',
    PARTNER: 'PARTNER',
    PARTNER2: 'PARTNER2',
    REGISTRY: 'REGISTRY',
    TRANSFER: 'TRANSFER',
    CONVERSION: 'CONVERSION',
    CONTRIBUTION: 'CONTRIBUTION',
    RED: 'RED',
    REGISTER: 'REGISTER',
    REPRESENTATION: 'REPRESENTATION',
    REPRESENTATION2: 'REPRESENTATION2',
    REFEREE: 'REFEREE',
    REFEREE2: 'REFEREE2',
    RS: 'RS',
    ROSTER: 'ROSTER',
    COMPETITION: 'COMPETITION',
    SPORTSFIELD: 'SPORTSFIELD',
    SUPERUSER: 'SUPERUSER',
    TRANSFERS: 'TRANSFERS',
    TASK: 'TASK',
    VM: 'VM',
    YOUTUBE: 'YOUTUBE',
    SUPER_LINK: 'SUPER_LINK',
    SUPER_ROSTER: 'SUPER_ROSTER',
};
